import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import { getSelectedAccountType } from "containers/Accounts/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as createReducer from "containers/CreateWizard/reducer";
import * as runReducer from "containers/Run/reducer";
import * as loginReducer from "containers/Login/reducer";
import * as deployReducer from "containers/Deploy/reducer";
import * as deploymentsReducer from "containers/Deployments/reducer";
import * as predictReducer from "containers/Predict/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as recipeReducer from "containers/Recipe/reducer";
import * as projectReducer from "containers/Project/reducer";
import * as businessReducer from "containers/Business/BusinessReducer";

import Train from "components/Business/Train/Train";

class TrainContainer extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { deploy: false };

    props.initPredict();
  }

  render() {
    return <Train {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  initJob: () => {},

  updateDrilldownValue: (runId, drilldownValue) =>
    dispatch(projectReducer.updateDrilldownValue(ownProps.projectId, runId, drilldownValue)),

  updateChooseModel: (model) => dispatch(runReducer.updateFeatureSelection(ownProps.id, model, true)),
  updateIgnoredModel: (model, value) => dispatch(setupReducer.updateIgnoredModel(ownProps.id, model, value)),
  setIsAllowedInFrontier: (modelName, isAllowed) =>
    dispatch(projectReducer.setIsAllowedInFrontier(ownProps.id, modelName, isAllowed)),

  updateDeploy: () => dispatch(runReducer.toggleDeploy(ownProps.id)),
  updateShowDeploy: (showDeploy) => dispatch(runReducer.updateShowDeploy(ownProps.id, showDeploy)),
  updateImpact: (impactType, impact) => dispatch(setupReducer.updateImpact(ownProps.id, impactType, impact)),
  resetDefaults: () => dispatch(setupReducer.resetDefaults(ownProps.id)),
  updateFieldSelect: (fieldSelect) => dispatch(runReducer.updateFieldSelect(ownProps.id, fieldSelect)),
  updateValueSelect: (valueSelect) => dispatch(runReducer.updateValueSelect(ownProps.id, valueSelect)),
  updateIsFeatureOpen: (isOpen) => dispatch(loginReducer.updateIsFeatureOpen(isOpen)),
  updateProcessLimit: (processLimit) => dispatch(setupReducer.updateProcessLimit(ownProps.id, processLimit)),
  updateProcessLimitPct: (processLimitPct) =>
    dispatch(setupReducer.updateProcessLimitPct(ownProps.id, processLimitPct)),
  updateIsNextStep: (isNextStep) => dispatch(runReducer.updateIsNextStep(ownProps.id, isNextStep)),

  testPredict: () => dispatch(deployReducer.testPredict(ownProps.id)),

  handleRestfulDeploy: (modelId) => dispatch(deploymentsReducer.handleRestfulDeploy(ownProps.id, modelId)),
  stopDeploy: (deployId) => dispatch(deploymentsReducer.stopDeploy(deployId)),

  initPredict: () => dispatch(predictReducer.init(ownProps.id)),
  updateCurrentStep: (stepId) => dispatch(businessReducer.updateCurrentStep(ownProps.projectId, stepId)),

  retrainRun: () => dispatch(projectReducer.retrainRun(ownProps.projectId))
});

const mapStateToProps = (state, ownProps) => {
  const models = runReducer.getTransformedSortedModels(state, ownProps.id);
  const bestModel = models && models.length > 0 ? models[0] : undefined;
  const selModel = runReducer.getSelModel(state, ownProps.id, models);

  const deployRecipeId = blueprintReducer.getDeployRecipeId(state, setupReducer.getBlueprintId(state, ownProps.id));

  let optimized = ownProps.optimized;
  if (!optimized || optimized.id !== ownProps.projectId) {
    optimized = projectReducer.getOptimized(state, ownProps.projectId);
  }

  let modelGroups = ownProps.modelGroups;
  if (!modelGroups || modelGroups.id !== ownProps.projectId) {
    modelGroups = projectReducer.getModelGroups(state, ownProps.projectId);
  }

  return {
    step: createReducer.getStep(state),
    models: models,
    model: selModel,
    bestModel: bestModel,
    ignoredModels: setupReducer.getIgnoredModels(state, ownProps.id),
    modelIsAllowedInFrontier: selModel ? projectReducer.getIsAllowedInFrontier(state, ownProps.id, selModel.id) : false,
    fieldSelect: runReducer.getFieldSelect(state, ownProps.id),
    isDeploy: runReducer.getIsDeploy(state, ownProps.id),
    isError: runReducer.getIsError(state, ownProps.id),
    errorMessages: runReducer.getErrors(state, ownProps.id),
    cloudURL: runReducer.getCloudURL(state, ownProps.id),
    showDeploy: runReducer.getShowDeploy(state, ownProps.id),
    labels: setupReducer.getLabels(state, ownProps.id),
    netImpactLabel: setupReducer.getNetImpactLabel(state, ownProps.id),
    isDefaultImpacts: setupReducer.getIsDefaultImpacts(state, ownProps.id),
    selectedDataset: setupReducer.getDatasetFromSetup(state, ownProps.id),
    isContinuous: setupReducer.getOutcomeType(state, ownProps.id) === "number",
    isTwoMinuteRun: setupReducer.getIsTwoMinuteRun(state, ownProps.id),
    isQuickRun: setupReducer.getIsQuickRun(state, ownProps.id),
    fieldNames: setupReducer.getFieldNames(state, ownProps.id),
    processLimit: setupReducer.getProcessLimit(state, ownProps.id),
    setupChanged: setupReducer.getSetupChanged(state, ownProps.id),
    deployment: deploymentsReducer.getDeployment(state, ownProps.id, selModel && selModel.id),
    selectedAccountType: getSelectedAccountType(state),
    relatedJobs: runReducer.getRelatedJobs(state, ownProps.id),
    deployRecipeId: deployRecipeId,
    deployRecipeName: recipeReducer.getRecipeName(state, deployRecipeId),
    isEditBlueprint: blueprintReducer.getIsEditing(state, ownProps.blueprintId),

    isForceOptimized: setupReducer.getIsForceOptimized(state, ownProps.id),

    trueAction: setupReducer.getTrueAction(state, ownProps.id, true),

    isNextStep: runReducer.getIsNextStep(state, ownProps.id),
    frontierModels: runReducer.getFrontierList(state, ownProps.id),

    optimized: optimized,

    estimatedRunCost: runReducer.getEstimatedRunCost(state, ownProps.id),
    runCost: runReducer.getRunCost(state, ownProps.id, ownProps.projectId),

    isRetraining: projectReducer.getIsRetraining(state, ownProps.projectId),

    hasSetupIgnoreChanged: setupReducer.getSetupIgnoreChanged(state, ownProps.id),

    segments: projectReducer.getSegments(state, ownProps.projectId),
    modelGroups: modelGroups,

    unitRevenue: projectReducer.getUnitRevenue(state, ownProps.id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(TrainContainer);
